// extracted by mini-css-extract-plugin
module.exports = {"btnIcon":"btnIcon--2ibKG","btnAccept":"btnAccept--jOzhQ","btnDecline":"btnDecline--ZHSGQ"};